module.exports = __webpack_public_path__ + "static/img/mission.78aaad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/mission.png
// module id = Dqm2
// module chunks = 7